/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, { Component } from "react";
//import { Container, Icon, Image, Menu } from "semantic-ui-react";
//import { Header } from "semantic-ui-react";
import styles from "./Navbar.module.css";
import amgen from "./images/amgen.png";
import home from "./images/home.svg";
import logout from "./images/logout.svg";
import user from "./images/user.svg";
import { Button, Modal } from "semantic-ui-react";
import { withRouter } from "react-router-dom";

class Navbar extends Component {
  state = { modalOpen: false };
  async logout(e) {
    e.preventDefault();
    this.setState({ modalOpen: true });
  }
  handleClose = async () => {
    // e.preventDefault();
    this.setState({ modalOpen: false });
    await this.props.msalContext.instance.logoutRedirect({
      account: this.props.msalContext.instance.getActiveAccount(),
      postLogoutRedirectUri: window.location.origin + "/Logout"
    });

    //window.location = window.location.origin + "/logout.html";
  };

  render() {
    const path = window.location.pathname.slice(1);
    if (!this.props.authenticated || !this.props.showNavBar) {
      return "";
    }

    return (
      <div className={styles.container_shadow}>
        <nav className={styles.headerTextAlign}>
          <img
            alt=""
            src={amgen}
            height="30hv"
            width="8%"
            className={styles.amgen_logo}
          />
          {path === "TASReport" && (
            <span className={styles.reporttype}>
              <p className={styles.sas}>
                Training Assignment Status Report - Assignment Vehicle
              </p>
              <br></br>
              <p className={styles.lms}>Learning Management System Reports</p>
            </span>
          )}
          {path === "TASLAReport" && (
            <span className={styles.reporttype}>
              <p className={styles.sas}>
                Training Assignment Status Report - Learning Activities
              </p>
              <br></br>
              <p className={styles.lms}>Learning Management System Reports</p>
            </span>
          )}
          {path === "SASReport" && (
            <span className={styles.reporttype}>
              <p className={styles.sas}>
                Student Assignment Status (for Managers and Staff)
              </p>
              <br></br>
              <p className={styles.lms}>Learning Management System Reports</p>
            </span>
          )}

          <a href="/" target="_self">
            <img
              src={home}
              alt=""
              height="30hv"
              width="2%"
              className={styles.margin}
            />
          </a>
          <a href="#">
            <img
              src={user}
              alt=""
              height="27hv"
              width="2%"
              className={styles.margin}
            />
            {this.props.authenticated === true && (
              <span className={styles.user_name}>{this.props.username}</span>
            )}
          </a>
          {this.props.authenticated === true && (
            <a href="#" onClick={e => this.logout(e)}>
              <img
                src={logout}
                alt=""
                height="25hv"
                width="2%"
                className={styles.margin}
              />
              <span className={styles.logout}>Logout</span>
            </a>
          )}
        </nav>

        <Modal
          centered={false}
          open={this.state.modalOpen}
          size="mini"
          style={{ height: "23vh", marginTop: "30vh" }}
        >
          <Modal.Header>
            <p style={{ fontSize: "16px" }}>Logged out</p>
          </Modal.Header>
          <Modal.Content scrolling>
            <Modal.Description>
              <p style={{ fontSize: "14px" }}>
                This tab/window will be closed now
              </p>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="blue"
              className="button-hover submit-cancle"
              basic
              onClick={this.handleClose}
            >
              ok
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
export default withRouter(Navbar);
